import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface KnowledgeEntry {
  id: number;
  survey_session_id?: string;
  category: string;
  demographic_group: string;
  prompt: string;
  context?: string;
  ideal_response: string;
  avoid_patterns?: string;
  intent?: string;
  sentiment_score?: number;
  phq9_score?: number;
  gad7_score?: number;
  severity_level?: string;
  tags?: string;
  is_approved: number | boolean;
  training_ready: number | boolean;
  created_at?: string;
  updated_at?: string;
}

export interface KnowledgeListResponse {
  success: boolean;
  data: KnowledgeEntry[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    total_pages: number;
  };
}

export interface KnowledgeStatsResponse {
  success: boolean;
  stats: {
    total_entries: number;
    training_ready: number;
    categories: Array<{ category: string; count: number }>;
    demographics: Array<{ demographic_group: string; count: number }>;
  };
}

@Injectable({
  providedIn: 'root'
})
export class KnowledgebaseService {
  private apiUrl = environment.apiUrl + '/knowledgebase';

  constructor(private http: HttpClient) {}

  getList(params: any = {}): Observable<KnowledgeListResponse> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        httpParams = httpParams.set(key, params[key].toString());
      }
    });
    return this.http.get<KnowledgeListResponse>(this.apiUrl + '/list', { params: httpParams });
  }

  submitSurvey(data: any): Observable<any> {
    return this.http.post(this.apiUrl + '/submit', data);
  }

  getStats(): Observable<KnowledgeStatsResponse> {
    return this.http.get<KnowledgeStatsResponse>(this.apiUrl + '/stats');
  }

  getEntry(id: number): Observable<{ success: boolean; data: KnowledgeEntry }> {
    return this.http.get<{ success: boolean; data: KnowledgeEntry }>(`${this.apiUrl}/${id}`);
  }

  updateEntry(id: number, data: Partial<KnowledgeEntry>): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, data);
  }

  deleteEntry(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  exportDataset(): Observable<any> {
    return this.http.get(this.apiUrl + '/export');
  }
}
